var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRadar = function SvgRadar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 75
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#020303",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.126 19.983a1.277 1.277 0 0 0 .41-1.766l-.003-.003a1.293 1.293 0 0 0-1.768-.405c-10.264 6.38-13.379 19.817-6.958 30.014 6.424 10.196 19.952 13.29 30.218 6.91 6.1-3.793 9.94-10.316 10.271-17.457a1.284 1.284 0 0 0-1.239-1.329l-.093-.001a1.287 1.287 0 0 0-1.342 1.222c-.467 10.604-9.497 18.824-20.173 18.36-10.673-.464-18.948-9.434-18.481-20.038a19.2 19.2 0 0 1 9.158-15.507"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.746 32.003a1.213 1.213 0 0 0-1.34-1.068H74.4a1.21 1.21 0 0 0-1.064 1.339c.117.973.186 1.975.217 2.964.59 19.324-14.703 35.463-34.156 36.049-19.454.585-35.702-14.605-36.29-33.928-.48-15.711 9.64-29.812 24.747-34.484.641-.2.998-.879.798-1.517a1.22 1.22 0 0 0-1.528-.79C7.261 6.715-3.826 27.693 2.364 47.423c6.187 19.73 27.308 30.743 47.17 24.595C65.678 67.02 76.494 51.95 75.981 35.16c-.033-1.061-.068-2.123-.235-3.157"
  }))));
};
export default SvgRadar;